import {
  type IconButtonProps,
  IconButton as VolvoIconButton,
} from '@volvo-cars/react-icons';
import { forwardRef } from 'react';

type Props = Omit<IconButtonProps, 'color'> & {
  color?: 'accent' | 'destructive' | 'neutral';
};

const IconButton = forwardRef<HTMLButtonElement, Props>(
  ({ color, variant = 'clear', ...restProps }, ref) => (
    <VolvoIconButton
      ref={ref}
      variant={variant}
      color={color as any}
      {...(restProps as IconButtonProps)}
    />
  ),
);

IconButton.displayName = 'IconButton';

export default IconButton;
